import React from 'react';
import { useParams } from "react-router-dom";

// Mock user data (Replace with API data if needed)
const users = {
  "1": { name: "Alice", role: "Software Engineer", email: "alice@gmail.com", phone: "+91 1234567890", location: "Mumbai, India" },
  "2": { name: "Bob", role: "Full Stack Developer", email: "bob@gmail.com", phone: "+91 9876543210", location: "Delhi, India" },
  "3": { name: "Charlie", role: "Mobile Developer", email: "charlie@gmail.com", phone: "+91 9998887770", location: "Bangalore, India" }
};

function Fortfolio() {
  const { userId } = useParams(); // Get userId from URL
  const user = users[userId] || { name: "Unknown", role: "Guest", email: "N/A", phone: "N/A", location: "N/A" };

  return (
    <div className="container mt-5">
      <div className="row">
        {/* Left Profile Section */}
        <div className="col-md-4">
          <div className="card shadow-lg p-3 mb-5 bg-white rounded">
            <img 
              src={`/images/user${userId}.jpg`} 
              alt={user.name} 
              className="card-img-top rounded-circle mx-auto d-block mt-3" 
              style={{ width: "150px", height: "150px", objectFit: "cover" }}
            />
            <div className="card-body text-center">
              <h3 className="card-title">{user.name}</h3>
              <h5 className="text-muted">{user.role}</h5>

              <ul className="list-group list-group-flush text-start mt-3">
                <li className="list-group-item"><strong>Location:</strong> {user.location}</li>
                <li className="list-group-item"><strong>Email:</strong> {user.email}</li>
                <li className="list-group-item"><strong>Phone:</strong> {user.phone}</li>
              </ul>

              <button className="btn btn-primary mt-3">Let's Work Together</button>
            </div>
          </div>
        </div>

        {/* Main Content Section */}
        <div className="col-md-8">
          {/* About Me Section */}
          <div className="card shadow-sm p-3 mb-4">
            <div className="card-body">
              <h4>About Me</h4>
              <p>{user.name} is a passionate software developer with expertise in web and mobile app development.</p>
            </div>
          </div>

          {/* Education Section */}
          <div className="card shadow-sm p-3 mb-4">
            <div className="card-body">
              <h4>Education</h4>
              <ul>
                <li><strong>MCA</strong> - Pune University (2015-2018)</li>
                <li><strong>BCA</strong> - Sardar Patel University (2011-2014)</li>
              </ul>
            </div>
          </div>

          {/* Work Experience Section */}
          <div className="card shadow-sm p-3 mb-4">
            <div className="card-body">
              <h4>Work Experience</h4>
              <ul>
                <li>Freelancing in ASP.NET MVC (2019 - Present)</li>
                <li>Freelancing in React.js & React Native (2022 - 2023)</li>
              </ul>
            </div>
          </div>

          {/* Skills Section */}
          <div className="card shadow-sm p-3 mb-4">
            <div className="card-body">
              <h4>Technical Skills</h4>
              <ul>
                <li><strong>Programming Languages:</strong> C#, JavaScript</li>
                <li><strong>Frameworks:</strong> ASP.NET MVC, React.js, React Native, Node.js, Express.js</li>
                <li><strong>Databases:</strong> Microsoft SQL Server, MySQL, MongoDB</li>
                <li><strong>Tools:</strong> Git, GitHub, Azure, Postman, Visual Studio, Figma, Canva</li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Fortfolio;
